import { Quote, Star } from "lucide-react";

const testimonials = [
  {
    quote: "The structure helped me slow down and think clearly.",
    author: "Community Member"
  },
  {
    quote: "This changed how I approach decisions, not just tools.",
    author: "Community Member"
  },
  {
    quote: "Clear learning paths removed noise and confusion.",
    author: "Community Member"
  }
];

const CommunityExperiences = () => {
  return (
    <section id="community-experiences" data-testid="community-experiences-section" className="section-dark">
      <div className="section-glow center"></div>
      
      <div className="container">
        <div className="section-header">
          <div className="section-icon">
            <Quote />
          </div>
          <h2 className="section-title">Community Experiences</h2>
          <div className="section-divider"></div>
        </div>
        
        <div className="testimonial-grid">
          {testimonials.map((item, index) => (
            <div key={index} className="testimonial-card" data-testid={`quote-card-${index}`}>
              <Quote className="testimonial-quote-icon" size={48} />
              <div className="testimonial-stars">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={16} />
                ))}
              </div>
              <p className="testimonial-text">"{item.quote}"</p>
              <div className="testimonial-author">
                <div className="testimonial-avatar">
                  {item.author.charAt(0)}
                </div>
                <span className="testimonial-name">{item.author}</span>
              </div>
            </div>
          ))}
        </div>
        
        <p className="testimonial-note">
          (Education experiences only. No financial outcomes implied.)
        </p>
      </div>
    </section>
  );
};

export default CommunityExperiences;
